// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_k2p","colMin":"styles_colMin__22hWz"};